export default __webpack_public_path__ + "static/media/serenityseksenalti10.cf35ce3c.jpg";